import axios from "axios";

/**
 * Consulta los datos del tablero de soportes históricos
 * @param {Object} data - Datos de búsqueda
 * @returns {Promise<Array>} Lista de registros obtenidos
 */

export async function getSchemas() {
  try {
    const response = await axios.get("/MetaData/GetSchemas");
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getTables(data) {
  try {
    const response = await axios.get("/MetaData/GetTables/" + data);
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}

export async function getFields(dataSchema, dataFields) {
  try {
    const response = await axios.get(
      "/MetaData/GetFields/" + dataSchema + "/" + dataFields,
    );
    return response.data;
  } catch (error) {
    // Lanzamos el error para manejarlo en el componente
    throw error.response ? error.response : error;
  }
}
